import {
  PERSIST_SET
} from 'actions/persist'

function reducer(state = {
}, action) {
  switch (action.type) {
    case PERSIST_SET:
      if(!state.data) state.data = {}
      state[action.key] = action.value
      return Object.assign({}, state, {
        data:state.data
      })
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/persist.js